import notificationAudio from "../../src/assets/audios/notification.mp3";

// Store reference to current audio instance
let currentAudio = null;

export const playMessageSound = () => {
  // Stop and cleanup previous audio if it exists
  if (currentAudio) {
    currentAudio.pause();
    currentAudio.currentTime = 0;
    currentAudio = null;
  }

  // Create and play new audio
  currentAudio = new Audio(notificationAudio);

  // Cleanup reference when audio finishes
  currentAudio.addEventListener("ended", () => {
    currentAudio = null;
  });

  currentAudio.play().catch((err) => {
    console.log("Autoplay blocked:", err);
    currentAudio = null;
  });
};
